module.exports = __webpack_public_path__ + "static/media/QuickMessage14Sept2020.4bed259d.gif";